import react, { useEffect, useState, useContext } from "react";
import { Button } from "react-bootstrap";
import {
    BrowserRouter,
    Routes,
    Route,
    Link,
    useLocation,
    useNavigate,
} from "react-router-dom";
import './Menu.css';
import MenuUserImage from "./MenuUserImage";
import { AuthContext } from "../../../Context/AppContext";

const Navigation = () => {
    const { userInfo, setUserInfo, handleShowModalUserSettings } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname;

    const urlActiveManu = (str) => {
        let check = new RegExp('^' + str, 'i');
        return check.test(pathname);
    }

    const handlerLogOut = () => {
        localStorage.removeItem('token-api');
        setUserInfo({
            firstName: '',
            lastName: ''
        })
        navigate(`/`);
    }

    return (
        <div className="block-menu">
            <div className="user-block">
                <div className="user-block-avatar-container">
                    <MenuUserImage letters={`${userInfo.firstName ? userInfo.firstName[0] : ""}${userInfo.lastName ? userInfo.lastName[0] : ""}`} />
                </div>

                <div className="user-block-actions">
                    <div className="btn-action" onClick={handleShowModalUserSettings} title="Definições">
                        <i className="fa-solid fa-gear"></i>
                    </div>
                    <div className="btn-action" onClick={handlerLogOut} title="Sair">
                        <i className="fa-solid fa-right-from-bracket"></i>
                    </div>
                </div>
            </div>

            <div className="divisor"></div>

            <ul>
                <Link to="/my/dashboard" className={urlActiveManu('/my/dashboard') ? `active` : ``} >
                    <li>
                        <i className="fa-solid fa-house"></i>
                        <span className="ms-2">Página Inicial</span>
                    </li>
                </Link>
                <Link to="/my/nightspots" className={urlActiveManu('/my/nightspots') || urlActiveManu('/my/billing/manager') ? `active` : ``} >
                    <li>
                        <i className="fa-solid fa-location-dot"></i>
                        <span className="ms-2">Nightspots</span>
                    </li>
                </Link>
                <Link to="/my/events" className={urlActiveManu('/my/events') ? `active` : ``}>
                    <li>
                        <i className="fa-regular fa-calendar-days"></i>
                        <span className="ms-2">Eventos</span>
                    </li>
                </Link>
                <Link to="/my/promoters" className={urlActiveManu('/my/promoters') ? `active` : ``}>
                    <li>
                        <i className="fa-solid fa-users"></i>
                        <span className="ms-2">Promotores</span>
                    </li>
                </Link>
                <Link to="#" className={urlActiveManu('/my/campains') ? `active` : `disabled-link`}>
                    <li>
                        <i className="fa-solid fa-bolt"></i>
                        <span className="ms-2">Campanhas</span>
                        <span className="badge bg-warning text-dark">Brevemente</span>
                    </li>
                </Link>
            </ul>
        </div>
    )
}



const NavigationMobile = () => {
    const { userInfo, setUserInfo, handleShowModalUserSettings } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname;

    const urlActiveManu = (str) => {
        let check = new RegExp('^' + str, 'i');
        return check.test(pathname);
    }

    const handlerLogOut = () => {
        localStorage.removeItem('token-api');
        setUserInfo({
            firstName: '',
            lastName: ''
        })
        navigate(`/`);
    }

    const [showMobileMenu, setShowMobileMenu] = useState(false)
    useEffect(() => {
        console.log(showMobileMenu)
    }, [showMobileMenu])


    return (
        <nav role='navigation'>
            <div id="menuMobileToggle">

                <input type="checkbox" />

                <span></span>
                <span></span>
                <span></span>

                <ul id="menuMobile">
                    <Link to="/my/dashboard" className={urlActiveManu('/my/dashboard') ? `active` : ``} ><li><i className="fa-solid fa-house me-2"></i>&nbsp;Página Inicial</li></Link>
                    <Link to="/my/nightspots" className={urlActiveManu('/my/nightspots') ? `active` : ``} ><li><i className="fa-solid fa-location-dot me-2"></i>&nbsp;Nightspots</li></Link>
                    <Link to="/my/events" className={urlActiveManu('/my/events') ? `active` : ``}><li><i className="fa-regular fa-calendar-days me-2"></i>&nbsp;Eventos</li></Link>
                    <Link to="/my/promoters" className={urlActiveManu('/my/promoters') ? `active` : ``}><li><i className="fa-solid fa-users me-2"></i>&nbsp;Promotores </li></Link>
                    {/* <Link to="#" className={urlActiveManu('/my/campains') ? `active` : `disabled-link`}><li><i className="fa-solid fa-bolt"></i>&nbsp;Campanhas <span className="badge bg-warning">Soon</span></li></Link> */}
                </ul>
            </div>
        </nav>
    )

    return (
        <nav className="navbar navbar-dark float-end" aria-label="First navbar example">
            <div className="container-fluid">
                <button className="navbar-toggler " type="button" onClick={() => setShowMobileMenu(!showMobileMenu)} aria-controls="navbarsExample01" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarsExample01">
                    <div className="menu-rightToggle">
                        <input type="checkbox" onChange={() => setShowMobileMenu(!showMobileMenu)} checked={'checked'} />
                    </div>
                    <ul className={`menu-right ${showMobileMenu ? `active` : ``}`}>
                        <a href="#"><li>Home</li></a>
                        <a href="#"><li>About</li></a>
                        <a href="#"><li>Info</li></a>
                        <a href="#"><li>Contact</li></a>
                        <a href="https://erikterwan.com/" target="_blank"><li>Show me more</li></a>
                    </ul>
                </div>
            </div>
        </nav>
    )
}



export {
    Navigation,
    NavigationMobile
};